module.exports = __webpack_public_path__ + "img/信息申报.b7e5192f.png";